import { render, staticRenderFns } from "./guias.vue?vue&type=template&id=b43bfe4c"
import script from "./guias.vue?vue&type=script&lang=js"
export * from "./guias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports